import React, { useEffect } from 'react';

import { useAllSelector } from "../../services/selectors/allSelector"
import { useAuthSelector } from '../../services/selectors/authSelector';
import { authSelectedPharmacist } from '../../services/apis/auth/selectedPharmacistID';
import { findPharmacistById, getPharmacistDisplayName, idsMatch } from '../../utils/helper/helper';

import * as Hooks from '../../hooks';

export const PharmacistSelection = ({
    signatureErrors,
    setSignatureErrors,
    setShowData
}) => {

    const dispatch = Hooks.useCustomDispatch()

    const { pharmacistDetail, driverDefaultPharmacistId } = useAllSelector()
    const { driverSelectedPharmacist, selectedPharmacistID } = useAuthSelector()

    const defaultPharmacist = findPharmacistById(pharmacistDetail, driverDefaultPharmacistId)
    const defaultPharmacistName = getPharmacistDisplayName(defaultPharmacist)
    const selectedPharmacist = findPharmacistById(pharmacistDetail, selectedPharmacistID) || defaultPharmacist
    const signingPharmacistName = getPharmacistDisplayName(selectedPharmacist)
    const defaultPharmacistQuestionName = defaultPharmacistName || 'PHARMACIST OF THE DAY'
    const otherPharmacists = Array.isArray(pharmacistDetail)
        ? pharmacistDetail.filter((pharmacist) => !idsMatch(pharmacist?.id, defaultPharmacist?.id))
        : []
    const selectedOtherPharmacistId = otherPharmacists.some((pharmacist) => idsMatch(selectedPharmacistID, pharmacist?.id))
        ? selectedPharmacistID
        : ''

    useEffect(() => {
        if (!selectedPharmacistID && !driverSelectedPharmacist?.loading && defaultPharmacist?.id) {
            dispatch(authSelectedPharmacist(defaultPharmacist.id))
            setSignatureErrors(prevState => ({ ...prevState, pharmacistID: null }))
        }
        return () => {}
    }, [defaultPharmacist?.id, dispatch, driverSelectedPharmacist?.loading, selectedPharmacistID, setSignatureErrors])

    const handlePharmacySelect = (id) => {
        dispatch(authSelectedPharmacist(id))
        setShowData(true);

        setTimeout(() => {
            const windowHeight = window.innerHeight;
            const scrollAmount = windowHeight / 3;
            window.scrollBy({ top: scrollAmount, behavior: "smooth" });
        }, 100);

        setSignatureErrors({ ...signatureErrors, pharmacistID: null })
    }

    const handleOtherPharmacistSelect = (event) => {
        const selectedId = event.target.value || defaultPharmacist?.id

        if (!selectedId) {
            return
        }

        handlePharmacySelect(selectedId)
    }

    if (!defaultPharmacist?.id) {
        return (
            <React.Fragment>
                <div className='shadow-md flex grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 border border-gray-100 mb-2 rounded-md p-2'>
                    {pharmacistDetail?.map((value, index) => (
                        <div key={index} className=" bg-white border border-gray-100 m-1 p-2  rounded-md">
                            <label htmlFor={`item-checkbox-${index}`} className="cursor-pointer flex items-center gap-2">
                                <div className="w-6 h-6 bg-gray-200 rounded-full overflow-hidden">
                                    <img className="w-full h-full object-cover" alt='' src={value?.cover_photo} />
                                </div>
                                <div className="flex-grow">
                                    <h1 className="text-sm font-medium text-gray-900">{value?.name?.toUpperCase()}</h1>
                                </div>
                                <div className="flex-shrink-0">
                                    <input id={`item-checkbox-${index}`} type="radio" value={value.id} name="pharmacy-selection"
                                        className="peer" onChange={() => handlePharmacySelect(value.id)} checked={idsMatch(selectedPharmacistID, value.id)} />
                                </div>
                            </label>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }

    return (
        <React.Fragment>
            <div className='shadow-md border border-gray-100 mb-2 rounded-md p-3 bg-white'>
                <div className='flex flex-col sm:flex-row sm:items-start gap-3'>
                    <div className='flex flex-col gap-1'>
                        <span className='text-sm font-semibold text-gray-900'>Signing As</span>
                        <span className='inline-flex items-center rounded bg-green-50 px-3 py-1 text-lg font-semibold text-green-700 border border-green-100'>
                            {signingPharmacistName || 'Not selected'}
                        </span>
                    </div>

                    <label className='flex flex-col gap-1 text-sm font-semibold text-gray-900'>
                        <span>Not {defaultPharmacistQuestionName} ?</span>
                        <select
                            className='w-full sm:w-62 rounded-md border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-gray-900 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100'
                            value={selectedOtherPharmacistId}
                            onChange={handleOtherPharmacistSelect}
                            disabled={!defaultPharmacist?.id && otherPharmacists.length === 0}
                        >
                            <option value=''>Choose another pharmacist</option>
                            {otherPharmacists.map((pharmacist) => (
                                <option key={pharmacist.id} value={pharmacist.id}>
                                    {getPharmacistDisplayName(pharmacist) || pharmacist?.name}
                                </option>
                            ))}
                        </select>
                    </label>
                </div>
            </div>
        </React.Fragment>
    )
}
